import React from "react";
import { ArrowUpRight } from "lucide-react";
import SectionLabel from "./SectionLabel";

const FIELDS = [
  {
    key: "email",
    label: "EMAIL",
    value: "aryansrivastava0826@gmail.com",
    href: "mailto:aryansrivastava0826@gmail.com",
  },
  {
    key: "phone",
    label: "PHONE",
    value: "+91 — on request",
    href: "mailto:aryansrivastava0826@gmail.com?subject=Phone%20request",
  },
  {
    key: "linkedin",
    label: "LINKEDIN",
    value: "linkedin.com/in/aryan-srivastava2608",
    href: "https://www.linkedin.com/in/aryan-srivastava2608",
  },
  {
    key: "github",
    label: "GITHUB",
    value: "github.com/srivastava-aryan",
    href: "https://github.com/srivastava-aryan",
  },
  {
    key: "location",
    label: "LOCATION",
    value: "India — Remote friendly",
    href: null,
  },
];

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative"
    >
      <div className="mx-auto max-w-6xl px-6 pb-32 pt-24">
        <SectionLabel
          index="04"
          label="initiate_contact()"
          prompt
          testId="contact-label"
        />

        <div className="mt-10 grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <h2 className="font-mono text-3xl leading-tight text-ink-primary md:text-4xl">
              <span className="text-accent">{">"}</span> initiate_contact()
            </h2>
            <p className="mt-5 max-w-md font-sans text-base leading-relaxed text-ink-secondary">
              I read every message. If you&apos;re hiring for AI engineering
              or full-stack roles, or want to talk about a build, the fastest
              channel is email.
            </p>

            <a
              href="mailto:aryansrivastava0826@gmail.com?subject=Hi%20Aryan%20%E2%80%94%20let%27s%20talk"
              data-testid="contact-mailto-btn"
              className="btn-terminal mt-8 inline-flex items-center gap-2 border border-accent/60 bg-transparent px-5 py-3 font-mono text-sm uppercase tracking-widest text-accent"
            >
              <span className="text-accent/70">[</span>
              <span>SEND_MESSAGE</span>
              <span className="text-accent/70">]</span>
              <ArrowUpRight size={14} />
            </a>
          </div>

          {/* Terminal-style key-value list */}
          <div className="md:col-span-7">
            <div className="border border-line bg-bg-surface/60">
              {/* Terminal chrome */}
              <div className="flex items-center justify-between border-b border-line px-4 py-2 font-mono text-[11px] uppercase tracking-[0.22em] text-ink-dim">
                <div className="flex items-center gap-1.5">
                  <span className="h-2 w-2 rounded-full bg-ink-dim/60" />
                  <span className="h-2 w-2 rounded-full bg-ink-dim/60" />
                  <span className="h-2 w-2 rounded-full bg-accent/70" />
                </div>
                <span>~/contact.sh</span>
                <span>SHELL :: zsh</span>
              </div>

              <div className="px-5 py-5 font-mono text-sm">
                <p className="text-ink-dim">
                  <span className="text-accent">root@portfolio</span>:~#{" "}
                  <span className="text-ink-primary">./contact.sh --print</span>
                </p>
                <ul className="mt-4 space-y-3">
                  {FIELDS.map((f) => (
                    <li
                      key={f.key}
                      data-testid={`contact-field-${f.key}`}
                      className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:gap-4"
                    >
                      <span className="min-w-[110px] text-ink-dim">
                        {f.label}
                        <span className="text-accent">:</span>
                      </span>
                      {f.href ? (
                        <a
                          href={f.href}
                          target={
                            f.href.startsWith("http") ? "_blank" : undefined
                          }
                          rel="noopener noreferrer"
                          className="break-all text-ink-primary underline decoration-line decoration-1 underline-offset-4 transition hover:text-accent hover:decoration-accent"
                        >
                          {f.value}
                        </a>
                      ) : (
                        <span className="text-ink-primary">{f.value}</span>
                      )}
                    </li>
                  ))}
                </ul>
                <p className="mt-5 text-ink-dim">
                  <span className="text-accent">root@portfolio</span>:~#{" "}
                  <span className="cursor-blink" />
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer line */}
        <div className="mt-20 border-t border-line pt-6">
          <div className="flex flex-wrap items-center justify-between gap-3 font-mono text-[11px] uppercase tracking-[0.22em] text-ink-dim">
            <span>© {new Date().getFullYear()} ARYAN_SRIVASTAVA</span>
            <span>:{new Date().toLocaleString()}</span>
            <span>EOF</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
